import * as React from 'react';
import {useState,useEffect} from 'react';
import { useSelector } from 'react-redux';
import {Grid,Box, Dialog, DialogTitle, DialogActions, Button, Typography} from '@mui/material';
import Tree from "react-d3-tree";
import "../../style.css";
import NodeLbl from '../../NodeLabel/NLbl';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import AddStrategy from '../../../MissionAndStrategy/LComponents/AddStrategy/AddStrategy';
import EditMission from '../../../MissionAndStrategy/LComponents/EditMission/EditMission';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import EditStrategy from '../../../MissionAndStrategy/LComponents/EditStrategy/EditStrategy';
import { useGetStrategyMapTenantId } from '../../Hooks';
import CircularProgress from '@mui/material/CircularProgress';
import EditObjective from '../../../OKRManagment/Forms/EditObjective/EditObjective';
import CreateObjective from '../../../OKRManagment/Forms/CreateObjective/CreateObjective';
import { CreateKeyResult } from '../../../OKRManagment/Forms/CreateKeyResult/CreateKeyResult';
import { EditKeyResult } from '../../../OKRManagment/Forms/EditKeyResult/EditKeyResult';
import LoadingSpinner from '../../../../components/Progress/LoadingSpinner';
// import { FaEdit, FaTrash } from "react-icons/fa";

const test = {
    shape: "rect",
    shapeProps: {
        width: 0,
        height: 0,
        x: -20,
        y: 20,
        stroke: "#2F80ED"
    }
};

// const renderCustomNodeElement = ({ nodeDatum, toggleNode }:any) => (
//   <g>
//     <text fill="black" x="20" y="-10" fontSize="14">
//       {nodeDatum.name}
//     </text>

//     <g>
//       <text x="20" y="10" fontSize="12" fill="blue" cursor="pointer" onClick={() => handleEditClick(nodeDatum)}>
//         <FaEdit />
//       </text>
//       <text x="50" y="10" fontSize="12" fill="red" cursor="pointer" onClick={() => handleDeleteClick(nodeDatum)}>
//         <FaTrash />
//       </text>
//     </g>
//   </g>
// );

// توابع OnClick برای آیکون‌ها
const handleEditClick = (nodeDatum:any) => {
  console.log("Edit clicked for node:", nodeDatum);
};

const handleDeleteClick = (nodeDatum:any) => {
  console.log("Delete clicked for node:", nodeDatum);
};

  
  const StrategyMapp = (periodsData:any,periodId:string) => {
    
    // const [objNameIds, setObjNameIds] = useState<any>();
    // useEffect(() => {
    //     if(periodsData){
    //       let length = periodsData?.map((e: any) => e.isCurrent).indexOf(true);
    //       setPeriodId(periodsData[length].id);
    //     }
      
    // }, [periodsData]);
    // const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
    const tenantId: string = useSelector(
      (state: any) => state.meetings.profileTenantId
    );
    // const onSuccesssGetAllObjectiveData = (data: any) => {
    //   setObjNameIds(data);
    // };
    const onSuccesssGetAllObjectiveData = (data: any) => {
    };
    const{data:dataa,isLoading:dataLoading,refetch:getAgain}=
            useGetStrategyMapTenantId(periodsData?.periodId,tenantId,onSuccesssGetAllObjectiveData)
            
    const dataaa = [
      {
          name: "",
          children: [
          ]
      }
    ];

    const personId=useSelector((state:any)=>state.loign.personId);
    const [showAddStaff, setShowAddStaff] = useState<Boolean | null>(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditModalS, setShowEditModalS] = useState<boolean>(false);
    const [selectedNode, setSelectedNode] = useState<any>(null);
    const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
    const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
    const [userAsynOpcState, setUserAsyncOpState] = useState<any>(null);
    const [showAddObjective, setShowAddObjective] = useState<boolean>(false);
    const [showEditObjective, setShowEditObjective] = useState<Boolean | null>(false);
    const [objectiveAsynOpcState, setObjectiveAsyncOpState] = useState<any>(null);
    const[showEditKr,setShowEditKr]=useState<boolean>(false);
    const[showCreateKr,setShowCreateKr]=useState<Boolean|null>(false);
    const [open, setOpen] = React.useState(false);
    const[addKrState,setAddKrState]=useState<any>(null);
    // const handleNodeClick = (nodeData: any) => {
    //     if(nodeData?.type === 'Strategy'){
    //       setShowAddStaff(true);

    //     }else if(nodeData?.type === 'Goal'){
    //       setShowEditModal(true);
    //     }
    //     setSelectedNode(nodeData);
    // };

    const handleEditClick = (nodeData:any) => {
      setSelectedNode(nodeData);
      console.log("Edit clicked for node:", nodeData);
      if(nodeData?.type === 'Strategy'){
        setShowEditModalS(true);

      }else if(nodeData?.type === 'Goal'){
        setShowEditModal(true);
      }else if(nodeData?.type === 'Objective' || nodeData?.type === 'Objective2' || nodeData?.type === 'Objective3'){
        setShowEditObjective(true);
      } else if(nodeData?.type === 'keyResult' || nodeData?.type === 'keyResult2' || nodeData?.type === 'keyResult3'){
        setShowEditKr(true);
      }
      //console.log("Edit clicked for node:", node);
    };
  
    const initialDelete=(id:any)=>{
      let deleteBody={
          DeletedId:id,
          TenantId:tenantId
      }
      console.log(deleteBody);
      // deletePerson(deletePersonBody);
      handleClos();
    };

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClos = () => {
      setOpen(false);
    };

    const handleDeleteClick = (nodeData:any) => {
      setSelectedNode(nodeData);
      console.log(nodeData);
      handleClickOpen();
    };

    <Dialog
        fullScreen={true}
        open={open}
        onClose={handleClos}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
          {"آیا از حذف اطمینان دارید؟"}
        </DialogTitle>
        <DialogActions >
          <Button autoFocus onClick={handleClos} >
            <Typography  color={'red'}> انصراف</Typography> 
          </Button>
          <Button autoFocus onClick={()=>{ initialDelete(selectedNode?.idd)}} >
            <Typography  color={'#00387C'} > تایید</Typography> 
          </Button>
        </DialogActions>
      </Dialog>

    const handleAddClick = (nodeData:any) => {
      setSelectedNode(nodeData);
      if(nodeData?.type === 'Strategy'){
        setShowAddStaff(true);

      }else if(nodeData?.type === 'Goal'){
        setShowEditModal(true);
      }
      else if(nodeData?.type === 'Objective' || nodeData?.type === 'Objective2' || nodeData?.type === 'Objective3'){
        setShowAddObjective(true);
      }
      else if(nodeData?.type === 'keyResult' || nodeData?.type === 'keyResult2' || nodeData?.type === 'keyResult3'){
        setShowCreateKr(true);
      }
    };

    if (dataLoading) {
      return (<Box  width={'100%'} >
        <LoadingSpinner />
      </Box>)
    }

    return (
     <Grid item xs={12}>
       <Box>
        <div className="AppVer">
        <div id="treeWrapper"  style={{ width:'100%', height: '75vh'}}>
          <Tree
            data={dataa !== undefined && dataa != null ? dataa : dataaa}
            nodeSvgShape={test}
            pathFunc="straight"
            separation={{ siblings: 1.55 , nonSiblings: 1.55 }}
            orientation="vertical"
            translate={{ x: 900, y: 55 }}
            allowForeignObjects
            nodeLabelComponent={{
              render: 
              <NodeLbl 
                onEdit={handleEditClick}
                onDelete={handleDeleteClick}
                onAdd={handleAddClick}
                className="myLabelComponentInSvg" 
                nodeData={{name:'',type:'',score : null}}
                />,
                foreignObjectWrapper: {
                  width: 190,
                  height: 110,
                  y: -20,
                  x: -130,
              },
            }}
            zoomable= {true}
            // // // // initialDepth={200}
            // // // // shouldCollapseNeighborNodes={true}
            // // // // collapsible={false}
            // initialDepth={0.02}
            initialDepth={4}
            shouldCollapseNeighborNodes={true}
            //onClick={handleNodeClick} 
          />
        </div>
      </div>
      </Box>

      {showAddStaff && (
          <ModalLyt
            showModal={showAddStaff}
            setShowModal={setShowAddStaff}
            height={500}
            //width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ایجاد استراتژی"}
          >
            <AddStrategy
              // onSuccesss={initialAddStaff}
              // periodsData={periodsData}
              onClose={setShowAddStaff}
              // periodId={periodId}
              onSuccess={getAgain}
              setShowToastMessage2={setShowToastMessage2}
              // setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}

        {showEditModal && (
          <ModalLyt
            showModal={showEditModal}
            setShowModal={setShowEditModal}
            height={500}
            //width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"هدف نهایی"}
          >
            <EditMission
              // personId={personId}
              //periodId={periodId}
              onClose={() => setShowEditModal(false)}
              initData1={selectedNode}
              onSuccess={getAgain}
              setShowToastMessage={setShowToastMessage}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}
        {showEditModalS && (
          <ModalLyt
            showModal={showEditModalS}
            setShowModal={setShowEditModalS}
            height={500}
            //width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ویرایش استراتژی"}
          >
            <EditStrategy
              periodId={selectedNode}
              onClose={setShowEditModalS}
              afterSuccess={getAgain}
              setShowToastMessage={setShowToastMessage}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}
        {
          showEditObjective  && ( <ModalLyt
            showModal={showEditObjective}
            setShowModal={setShowEditObjective}
            // width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            height={900}
            title={"ویرایش هدف"}
          >
             <EditObjective
              periodsData={periodsData?.periodsData}
              onSuccess={setShowEditObjective}
              setShowToastMessage={setShowToastMessage2}
              setObjectiveAsyncOpState={setObjectiveAsyncOpState}
              afterSuccess={getAgain}
              objectiveId={selectedNode?.idd}
              // onClose={setShowEditObjective}
              periodId={periodsData?.periodId}
              setEditObjectiveState={getAgain}
            />
          </ModalLyt>)
        }
        {
          showAddObjective && (
           <ModalLyt
           showModal={showAddObjective}
           setShowModal={setShowAddObjective}
          //  width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
           height={900}
           title={"هدف جدید"}
         >
           <CreateObjective
             periodsData={periodsData?.periodsData}
             onSuccess={setShowAddObjective}
             setShowToastMessage={setShowToastMessage2}
             //setAddObjectiveStatus = {setAddObjectiveStatus}
             setObjectiveAsyncOpState={setObjectiveAsyncOpState}
             afterSuccess={getAgain}
             periodId={periodsData?.periodId}
             onClose={setShowAddObjective}
           />
         </ModalLyt>)
        }
 {
      showCreateKr && <ModalLyt   
      showModal={showCreateKr}
      setShowModal={setShowCreateKr}
      // width={isMobile ? '350px' : '1200px'}  
      title={'ایجاد نتیجه کلیدی'}  >
       <CreateKeyResult
       setShowCreateKr={setShowCreateKr}
       addKrSuccess={getAgain}  
       definitionId = {selectedNode?.detail?.definitionLevelId}
       objectiveId = {selectedNode?.detail?.objectiveId}
       setShowToastMessage={setShowToastMessage}
       setAddKrState={setAddKrState}
        />
      </ModalLyt>
    }
    {
      showEditKr && <ModalLyt 
      // height={1100} 
      showModal={showEditKr}
      setShowModal={setShowEditKr}
      // width={isMobile ? '350px' : '1200px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
      title={'ویرایش نتیجه کلیدی'}
      >
      <EditKeyResult
      definitionId = {selectedNode?.teamId}
      setShowEditKeyResult={setShowEditKr}
      editKrSuccess={getAgain}  
      setShowToastMessage={setShowToastMessage}
      setShowToastMessage3={setShowToastMessage2}
      setAddKrState={setAddKrState}
      krId={selectedNode?.idd}
      Item={selectedNode?.detail}
      />
      </ModalLyt>
    }
         {showToastMessage && (
            <DYToastMessage
              isSuccess={userAsynOpcState?.isSuccess}
              message={userAsynOpcState?.metaData.message}
              setShow={setShowToastMessage}
              show={showToastMessage}
            />
          )}
          {showToastMessage2 && (
              <DYToastMessage
                isSuccess={true}
                message={'عملیات با موفقیت انجام شد'}
                setShow={setShowToastMessage2}
                show={showToastMessage2}
              />
            )}
     </Grid>
    );
  };
  
export default StrategyMapp